var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0361 -0.0328256L16.0329 1.96402C16.7511 2.68223 16.7511 3.84667 16.0329 4.56488L15.0345 5.5633L8.73236 11.8654C8.64614 11.9516 8.5292 12.0001 8.40726 12.0001H4.45977C4.20585 12.0001 4 11.7942 4 11.5403V7.59282C4 7.47088 4.04844 7.35394 4.13466 7.26772L10.4368 0.965599L11.4352 -0.0328261C12.1534 -0.751032 13.3179 -0.751031 14.0361 -0.0328256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4368 0.965599L4.13466 7.26772C4.04844 7.35394 4 7.47088 4 7.59282V11.5403C4 11.7942 4.20585 12.0001 4.45977 12.0001H8.40726C8.5292 12.0001 8.64614 11.9516 8.73236 11.8654L15.0345 5.5633M10.4368 0.965599L11.4352 -0.0328261C12.1534 -0.751032 13.3179 -0.751031 14.0361 -0.0328256L16.0329 1.96402C16.7511 2.68223 16.7511 3.84667 16.0329 4.56488L15.0345 5.5633M10.4368 0.965599L15.0345 5.5633",
    stroke: "#131316",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.7cb6a3330005673e4026ccc77ef95353.svg";
export { ForwardRef as ReactComponent };